export const appSliceName = 'app';
